// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://iaydpqbgutssogjfqygl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlheWRwcWJndXRzc29namZxeWdsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU1MjUyNDgsImV4cCI6MjA2MTEwMTI0OH0.ykLVVO5HkeWMR6-KCBQnMzHGBhQL64pRuE1TAYjaijc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);